module.exports = __webpack_public_path__ + "static/media/Pic.b0f2f1e7.png";